import { Button } from '@/components/atoms/Button';
import { Text } from '@/components/atoms/text';
import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ComparativeModalContainer = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    minWidth: '560px',
    maxHeight: 'calc(100% - 50px)',
  },
}));

export const ComparativeModalHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 1.5, 0),
}));

export const ComparativeModalHeaderContent = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ComparativeModalContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(1.5),
  maxHeight: '560px',
  overflowY: 'auto',
}));

interface ComparativeModalInputAmountProps {
  disabled?: boolean;
}

export const ComparativeModalInputAmount = styled(Text)<ComparativeModalInputAmountProps>(
  ({ theme, disabled }) => ({
    minWidth: '44px',
    maxWidth: '44px',
    height: '44px',
    borderRadius: '50%',
    backgroundColor: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.primary.main,
    color: disabled ? theme.palette.text.secondary : theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  })
);

export const ComparativeModalEmptyAmount = styled(Box)(() => ({
  minWidth: '44px',
  maxWidth: '44px',
  height: '44px',
  borderRadius: '50%',
  backgroundColor: 'transparent',
}));

export const ComparativeModalInput = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const ComparativeModalMoreButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const ComparativeModalMoreButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '44px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  color: theme.palette['mint-green'][800],
}));

export const ComparativeModalButtons = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(1.5),
}));
